module.exports = __webpack_public_path__ + "img/service-resource06.3081192d.jpg";